// extracted by mini-css-extract-plugin
export default {"container":"index_container__Av8WD","count":"index_count__iG4ad","arrow":"index_arrow__MCWf7","close":"index_close__+Zd5K"};